import { render, staticRenderFns } from "./AttachmentsForm.vue?vue&type=template&id=49009917&scoped=true&"
import script from "./AttachmentsForm.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsForm.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsForm.vue?vue&type=style&index=0&id=49009917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49009917",
  null
  
)

export default component.exports